import { gql } from '@apollo/client';

export const GET_FILES_FOR_METRIC_RECORDS_QUERY = gql`
  query getFilesForMetricRecordsQuery(
    $group_id: String
    $company_id: String
    $metric_record_id: String
  ) {
    files(group_id: $group_id, company_id: $company_id, metric_record_id: $metric_record_id) {
      id
      deleted
      name
      type
      uploaded
      file_path
      metric_record {
        id
        path
        parentPath
      }
    }
  }
`;

export const GET_DUPLICATE_FILE_FOR_METRIC_RECORD_QUERY = gql`
  query getDuplicateFilesForMetricRecordsQuery(
    $group_id: String
    $company_id: String
    $file_name: String
    $metric_record_id: String
  ) {
    getDuplicateFile(
      group_id: $group_id
      company_id: $company_id
      file_name: $file_name
      metric_record_id: $metric_record_id
    )
  }
`;
